export default "__VITE_ASSET__921f17db__"